// src/router/routerHelper.js
import { getCustomer } from "@/assets/Branding/branding.js"
import { Capacitor } from "@capacitor/core"

export async function getBookingPoisListComponent() {
  const customer = await getCustomer()
  if (customer === "pia") {
    return import("@/components/CustomerComponents/general/BookingPoisList.vue")
  } else if (customer === "hammerbrooklyn") {
    //return import('@/components/CustomerComponents/hbc/BookingViewHBC.vue')
    return import("@/components/general/BookingPoisList.vue")
  } else {
    return import("@/components/general/BookingPoisList.vue")
  }
}

export async function getBookingViewComponent() {
  const customer = await getCustomer()
  if (customer === "hammerbrooklyn") {
    return import("@/components/CustomerComponents/hbc/BookingViewHBC.vue")
  } else {
    return import("@/views/general/BookingView.vue")
  }
}

export async function getLandingPageComponent() {
  const customer = await getCustomer()
  if (customer === "pia") {
    return import("@/views/general/HomeView.vue")
  } else {
    return import("@/views/general/BuildingView.vue")
  }
}

export async function getLockViewComponent() {
  const customer = await getCustomer()
  if (customer === "pia" || customer === "hammerbrooklyn") {
    return import("@/components/CustomerComponents/hbc/LockViewSwitcher.vue")
  } else {
    return import("@/views/general/LocksView.vue")
  }
}

export async function getHomeViewName() {
  const customer = await getCustomer()
  if (customer === "pia") {
    return "HomeView"
  } else {
    return "InfoCenterView"
  }
}
export async function getHomeViewPath() {
  const customer = await getCustomer()
  if (customer === "pia") {
    return "/home"
  } else {
    return "/infocenter"
  }
}

export async function getHomeViewComponent() {
  const customer = await getCustomer()
  if (customer === "pia") {
    return import("@/views/general/HomeView.vue")
  } else {
    return import("@/views/general/InfoCenterView.vue")
  }
}
